import React from 'react';

import Text from '../../../../ui/Text';

import iconAutentic from '../../../../../assets/icons/autentic.svg';
import iconRegister from '../../../../../assets/icons/register.svg';
import iconAlcance from '../../../../../assets/icons/alcance.svg';

import * as Styles from './OnboardingListStyles';

const OnboardingList: React.FC = () => {
  return (
    <Styles.List>
      <Styles.ListItem>
        <Styles.ListItemIcon src={iconAutentic} />
        <Styles.Box>
          <Text color="white" scale="subtitle2">
            Autentique-se com <Styles.TextHighLight> SNGPC </Styles.TextHighLight>
          </Text>
          <Text color="white" scale="caption1">
            Validamos seus dados com a ANVISA para garantir que é uma farmácia ativa.
          </Text>
        </Styles.Box>
      </Styles.ListItem>
      <Styles.ListItem>
        <Styles.ListItemIcon src={iconRegister} />
        <Styles.Box>
          <Text color="white" scale="subtitle2">
            Registre a <Styles.TextHighLight> dispensação </Styles.TextHighLight>
          </Text>
          <Text color="white" scale="caption1">
            Evite dupla dispensação fazendo um registro digital no arquivo.
          </Text>
        </Styles.Box>
      </Styles.ListItem>
      <Styles.ListItem>
        <Styles.ListItemIcon src={iconAlcance} />
        <Styles.Box>
          <Text color="white" scale="subtitle2">
            Alcance mais <Styles.TextHighLight> pacientes </Styles.TextHighLight>
          </Text>
          <Text color="white" scale="caption1">
            Sua farmácia aparecerá como opção de compra para todos os pacientes com Receita Digital.
          </Text>
        </Styles.Box>
      </Styles.ListItem>
    </Styles.List>
  );
};

export default OnboardingList;
